import { render, staticRenderFns } from "./MDKForm.vue?vue&type=template&id=59e1dc96&"
import script from "./MDKForm.vue?vue&type=script&lang=js&"
export * from "./MDKForm.vue?vue&type=script&lang=js&"
import style0 from "./MDKForm.vue?vue&type=style&index=0&id=59e1dc96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports